import React from "react";

const classes = require("./Container.module.scss");

const Container = (props: { children: any; direction: string }) => {
    const configuredClasses =
        props.direction === "row"
            ? [classes.Container, classes.row].join(" ")
            : [classes.Container, classes.column].join(" ");
    return <div className={configuredClasses}>{props.children}</div>;
};

export default Container;
